// Constants
import { TaskGroupingOption, TaskGroupingState } from "@ms/uno-constants/lib/local/GroupingConstants";
import { KeywordFilterField } from "../constants/FilterConstants";
// Utilities
import { ConvertPercentCompleteToStatus } from "./ConversionUtilities";
/**
 * Map TaskGroupingState to TaskGroupingOption
 */ export function mapTaskGroupingStateToTaskGroupingOption(taskGroupingState) {
    switch(taskGroupingState){
        case TaskGroupingState.None:
            return TaskGroupingOption.None;
        case TaskGroupingState.Assignee:
            return TaskGroupingOption.Assignee;
        case TaskGroupingState.Bucket:
            return TaskGroupingOption.Bucket;
        case TaskGroupingState.Plan:
            return TaskGroupingOption.Plan;
        case TaskGroupingState.Progress:
            return TaskGroupingOption.Status;
        case TaskGroupingState.DueDate:
            return TaskGroupingOption.DueDate;
        case TaskGroupingState.Category:
            return TaskGroupingOption.Category;
        case TaskGroupingState.Priority:
            return TaskGroupingOption.Priority;
        case TaskGroupingState.ProjectManagerWorkflowState:
            return TaskGroupingOption.ProjectManagerWorkflowState;
        default:
            return TaskGroupingOption.None;
    }
}
/**
 * Map Uno task filter field names to Evo task filter field names
 */ export function mapUnoTaskFilterFieldNameToEvoTaskFilterFieldName(unoTaskField) {
    switch(unoTaskField){
        case "dueDate":
            return "dueDateTime";
        case "title":
            return KeywordFilterField;
        case "appliedCategories":
            return "planView.appliedCategoryIds";
        case "assignments":
            return "userAssignments";
        case "percentComplete":
            return "status";
        default:
            return unoTaskField;
    }
}
/**
 * Map Uno task filter field values to Evo task filter field values
 */ export function mapUnoTaskFilterFieldValuesToEvoTaskFilterFieldValues(unoTaskFieldName, unoTaskFieldValues) {
    switch(unoTaskFieldName){
        case "percentComplete":
            return unoTaskFieldValues.map((value)=>ConvertPercentCompleteToStatus(value));
        case "appliedCategories":
            return unoTaskFieldValues.map((value)=>mapUnoCategoryIdToEvoCategoryId(value));
        default:
            return unoTaskFieldValues;
    }
}
/**
 * Map Uno percent complete values to Evo status values
 */ export function mapUnoPercentCompleteValuesToEvoStatus(unoPercentComplete) {
    return ConvertPercentCompleteToStatus(unoPercentComplete);
}
/**
 * Map Uno category IDs to Evo category IDs
 */ export function mapUnoCategoryIdToEvoCategoryId(unoCategoryId) {
    if (unoCategoryId === null) {
        return "unlabeled";
    }
    // Convert number to hex and pad to 8 characters, then pad to 32 characters total
    const hexId = unoCategoryId.toString(16).padStart(8, "0");
    return hexId.padEnd(32, "0");
}
/**
 * Convert Uno filters to Evo filters
 */ export function convertUnoFiltersToEvoFilters(unoFilters) {
    return unoFilters.map((entry)=>({
            k: entry.k,
            v: {
                filters: entry.v.filters.map((f)=>({
                        field: mapUnoTaskFilterFieldNameToEvoTaskFilterFieldName(f.field),
                        values: mapUnoTaskFilterFieldValuesToEvoTaskFilterFieldValues(f.field, f.values)
                    }))
            }
        }));
}
export function convertUnoGroupingStatesToEvoGroupingStates(unoGroupingStates) {
    return unoGroupingStates.map((g)=>({
            k: g.k,
            v: mapTaskGroupingStateToTaskGroupingOption(g.v)
        }));
}
export function convertUnoSortCriteriaToEvoSortCriteria(unoSortCriteria) {
    return unoSortCriteria.map((s)=>({
            k: s.k,
            v: {
                primary: {
                    field: mapUnoTaskFilterFieldNameToEvoTaskFilterFieldName(s.v.primary.field),
                    isAscending: s.v.primary.isAscending
                }
            }
        }));
}
export function convertUnoGridColumnWidthsToEvoGridColumnWidths(unoGridColumnWidths) {
    return unoGridColumnWidths.map((g)=>({
            k: g.k,
            v: Object.fromEntries(Object.entries(g.v).map(([field, width])=>[
                    mapUnoTaskFilterFieldNameToEvoTaskFilterFieldName(field),
                    width
                ]))
        }));
}
